const initialState = {
  avoirs: [],
  pageCount: null,
  total: null,
  loading: false,
  error: null,
  currentAvoirs: null,
  currentAvoirsLoading: false,
  avoirLoading: false,
};

const avoirReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "AVOIRS_LOADING":
      return { ...state, loading: true, error: null };
    case "AVOIRS_SUCCESS": {
      const updatedAvoirs =
        payload?.meta?.pagination?.page === 1
          ? payload?.data
          : [...state.avoirs, ...payload?.data];
      return {
        ...state,
        loading: false,
        pageCount: payload?.meta?.pagination?.pageCount,
        total: payload?.meta?.pagination?.total,
        error: null,
        avoirs: updatedAvoirs,
      };
    }
    case "UPDATE_AVOIR_LOADING":
    case "CURRENT_AVOIRS_LOADING":
      return {
        ...state,
        currentAvoirsLoading: true,
        error: null,
      };
    case "CURRENT_AVOIRS_SUCCESS":
      return {
        ...state,
        currentAvoirsLoading: false,
        error: null,
        currentAvoirs: payload,
      };
    case "AVOIRS_ERROR":
      return { ...state, loading: false, error: payload };
    case "UPDATE_AVOIR_SUCCESS": {
      return { ...state, loading: false, error: null };
    }
    case "DELETE_CURRENT_AVOIR_SUCCESS":
      return {
        ...state,
        currentAvoirsLoading: true,
        currentAvoirs: state.currentAvoirs.filter(
          (avoir) => +avoir.id !== +payload
        ),
      };
    case "UPDATE_STATUS_AVOIR_SUCCESS": {
      const updatedAvoirs = state.avoirs.map((avoir) => {
        if (+avoir.id === +payload.id) {
          return {
            ...avoir,
            attributes: {
              ...avoir?.attributes,
              status: payload.status,
            },
          };
        }
        return avoir;
      });
      return {
        ...state,
        avoirs: updatedAvoirs,
      };
    }

    case "UPDATE_COMMENT_AVOIR_SUCCESS": {
      const updatedAvoirs = state.avoirs.map((avoir) => {
        if (+avoir.id === +payload.id) {
          return {
            ...avoir,
            attributes: {
              ...avoir?.attributes,
              comment: payload.comment,
            },
          };
        }
        return avoir;
      });
      return {
        ...state,
        avoirs: updatedAvoirs,
      };
    }
    case "DELETE_AVOIR_SUCCESS": {
      const updatedAvoirs = state.avoirs.filter(
        (avoir) => +avoir.id !== +payload
      );
      return {
        ...state,
        avoirs: updatedAvoirs,
      };
    }
    case "AVOIR_LOADING": {
      return { ...state, avoirLoading: true };
    }
    case "AVOIR_SUCCESS": {
      const updatedAvoirs = state.avoirs.map((avoir) => {
        if (+avoir.id === +payload.id) {
          return payload;
        }
        return avoir;
      });
      return {
        ...state,
        avoirLoading: false,
        avoirs: updatedAvoirs,
      };
    }

    case "DOWNLOAD_AVOIR_SUCCESS":
    case "AVOIR_ERROR":
      return { ...state, avoirLoading: false };

    case "RESET_AVOIRS": {
      return initialState;
    }
    default:
      return state;
  }
};

export default avoirReducer;
